import { Component, ViewChild } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams } from 'ionic-angular';
import { GoogleMap } from "../../../components/google-map";
import { ContentBlock } from "../../../models/content-block";
import { Entry } from "../../../models/entry";
import { FirebaseAnalytics } from "@ionic-native/firebase-analytics";
import { Api } from "../../../providers/api";
import { BookmarkService } from "../../../providers/bookmark-service";
import { GoogleMapsService } from "../../../providers/google-maps";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { Advert } from "../../../models/advert";

@Component({
    selector: 'page-entry',
    templateUrl: 'entry.html'
})
export class EntryPage {

    @ViewChild('map') public map: GoogleMap;

    public contentBlocks: ContentBlock[];
    public entry: Entry;
    public sections: Entry[];

    public isBookmarked: boolean = false;
    public location: string;
    public latLng: google.maps.LatLng = null;
    public breadcrumbs: string;

    public advert: Advert;

    constructor(
        public alertCtrl: AlertController,
        public analytics: FirebaseAnalytics,
        public api: Api,
        public bookmarks: BookmarkService,
        public googleMaps: GoogleMapsService,
        public loadingCtrl: LoadingController,
        public navCtrl: NavController,
        public navParams: NavParams,
        private iab: InAppBrowser,
    ) {
        this.contentBlocks = this.navParams.get('content_blocks');
        this.entry = this.navParams.get('entry');
        this.advert = this.navParams.get('advert');
        this.sections = Entry.sortByTitle(this.navParams.get('entries'));

        for (let block of this.contentBlocks) {
            if (block.location) {
                this.location = block.location;
                break;
            }
        }
    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('Entry');
        this.analytics.logEvent('entry_view', {
            entry_id: this.entry.id,
            entry_title: this.entry.title,
        });
    }

    public async ngAfterViewInit() {
        this.breadcrumbs = this.buildBreadcrumbs();

        this.isBookmarked = await this.bookmarks.has(this.entry.id);

        if (this.location) {
            this.latLng = await this.googleMaps.geocodeToLatLng(this.location);
            this.map.setCenter(this.latLng);
            this.map.addMarker({
                position: this.latLng
            });
        }
    }

    public async toggleBookmark(): Promise<boolean> {
        if (this.isBookmarked) await this.bookmarks.remove(this.entry);
        else await this.bookmarks.add(this.entry);

        this.isBookmarked = await this.bookmarks.has(this.entry.id);

        return this.isBookmarked;
    }

    public buildBreadcrumbs(): string {
        const breadcrumbs = [
            'Search Directory',
            this.entry.root_chapter.title,
            ...this.entry.parents.map((parent: Entry) => parent.title)
        ];

        const isLastElement = (index: number) => (index + 1) === breadcrumbs.length;

        return breadcrumbs.map((title, index) => {
            let li = document.createElement('li');

            let span = document.createElement('span');
            span.innerText = title;

            if (isLastElement(index)) {
                span.classList.add('item', 'current-item');
                li.appendChild(span);
            } else {
                span.classList.add('item-value');

                let separatorSpan = document.createElement('span');
                separatorSpan.classList.add('sep');
                separatorSpan.innerText = '|';

                li.appendChild(span);
                li.appendChild(separatorSpan);
            }

            return li.innerHTML;
        }).join('');
    }

    public getDirections(): void {
        this.iab.create(this.googleMaps.getUrlDirections(this.latLng), '_system');
    }
}



// WEBPACK FOOTER //
// ./src/pages/desktop/entry/entry.ts